module.exports = __webpack_public_path__ + "static/background-fill-37b0c0d6d93b767e9b6854c25353bc5f.jpg";